import { Link } from "react-router-dom";
import React, { useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../css/footer.css";
import policySamjhologo from '../assets/policySamjhologo.webp';
import { UserContext } from "../UserContext";

function Footer() {
  const { user, UserToken, userRole, } = useContext(UserContext);
  const isLoggedIn = !!user && UserToken && userRole;

  return (
    <>
      <div className=" newsletter mt-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="row justify-content-center gx-0">
          <div className="col-lg-10 border rounded p-1">
            <div className="border rounded text-center p-1">
              <div className="bg-light-dark rounded text-center p-5">
                <h4 className="mb-4 text-center">
                  <span className="text-white">Why Choose Us for</span>
                  <span style={{ color: "#F5A526", marginLeft: '10px' }}>Your Insurance Needs</span>
                </h4>
                <div className="row text-white">
                  <div className="col-md-6 col-lg-4 mb-3 d-flex justify-content-start align-items-start">
                    <div className="icon-container">
                      <i className="fas fa-user-shield me-2 mt-1"></i>
                    </div>
                    <span>Transparent Plans</span>
                  </div>
                  <div className="col-md-6 col-lg-4 mb-3 d-flex justify-content-start align-items-start">
                    <div className="icon-container">
                      <i className="fas fa-balance-scale me-2 mt-1"></i>
                    </div>
                    <span>Instant Understanding</span>
                  </div>
                  <div className="col-md-6 col-lg-4 mb-3 d-flex justify-content-start align-items-start">
                    <div className="icon-container">
                      <i className="fas fa-eye me-2 mt-1"></i>
                    </div>
                    <span>Learn Before You Decide</span>
                  </div>
                  <div className="col-md-6 col-lg-4 mb-3 d-flex justify-content-start align-items-start">
                    <div className="icon-container">
                      <i className="fas fa-bolt me-2 mt-1"></i>
                    </div>
                    <span>Compare & Choose Easily</span>
                  </div>
                  <div className="col-md-6 col-lg-4 mb-3 d-flex justify-content-start align-items-start">
                    <div className="icon-container">
                      <i className="fas fa-hands-helping me-2 mt-1"></i>
                    </div>
                    <span>Expert Insurance Guidance</span>
                  </div>
                  <div className="col-md-6 col-lg-4 mb-3 d-flex justify-content-start align-items-start">
                    <div className="icon-container">
                      <i className="fas fa-book-reader me-2 mt-1"></i>
                    </div>
                    <span>Personal Help, On-Demand</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer" className="container-fluid text-light footer wow fadeIn" data-wow-delay="0.1s">
        <div className="container pb-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-4">
              <div className="custom-dark-bg rounded p-4">
                <div className="d-flex align-items-center mb-3">
                  <Link to="/">
                    <img src={policySamjhologo} alt="Policy Samjho Logo" className="img-fluid me-3" style={{ maxHeight: '80px' }} />
                  </Link>
                </div>
                <p className="text-white mb-0 text-justify">
                  Policy Samjho IMF Private Limited. simplifies insurance for every Indian offering clear guidance,
                  expert help, and smart tools to help you understand, compare, and choose the right plan.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <h6 className="section-title text-start text-uppercase mb-4">Contact Us</h6>
              <p className="mb-1">
                <i className="fas fa-map-marker-alt me-2"></i> Corporate Office: 21-22, Shri Apartment, Above ICICI Bank, Saket Square, Indore (MP) Pin Code: 452018
              </p>
              <p className="mb-2" style={{ cursor: 'pointer' }}>
                <i className="fas fa-phone-alt me-2"></i>18005703990
              </p>
              <p className="mb-2" style={{ cursor: 'pointer' }}>
                <i className="fas fa-envelope me-2"></i>
                connect@policysamjho.com
              </p>
              <p className="mb-2 mt-3">
                <i className="fas fa-map-marker-alt me-2"></i> Registered Office: LG-1, Rudraksh Apartment, 16 Meerapath, Dhenu Market, Indore (MP) Pin Code: 452001
              </p>

              <p className="mb-2" style={{ cursor: 'pointer' }}>
                <i className="fas fa-phone-alt me-2"></i>18005703990
              </p>
              <p className="mb-2" style={{ cursor: 'pointer' }}>
                <i className="fas fa-envelope me-2"></i>
                connect@policysamjho.com
              </p>

              <div className="d-flex pt-2">
                <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/policysamjho" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a className="btn btn-outline-light btn-social" href="https://www.instagram.com/policysamjho?ig-sg-mxwd3brbgyzmjp5" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a className="btn btn-outline-light btn-social" href="https://www.linkedin.com/company/policysamjho/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a className="btn btn-outline-light btn-social" href="https://youtube.com/@policysamjho?si=yEujpa3OhzUEYqjI" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
                <a className="btn btn-outline-light btn-social" href="https://x.com/policysamjho" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-x" style={{ color: "#000" }}></i>
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-2">
              <h6 className="section-title text-start text-uppercase mb-4">Our Services</h6>
              <Link className="btn btn-link" to="/lifeinsurance">Life Insurance</Link>
              <Link className="btn btn-link" to="/homeinsurance">Home Insurance</Link>
              <Link className="btn btn-link" to="/healthinsurance">Health Insurance</Link>
              <Link className="btn btn-link" to="/carinsurance">Car Insurance</Link>
              <Link className="btn btn-link" to="/cyberinsurance">Cyber Insurance</Link>
            </div>

            <div className="col-md-6 col-lg-3">
              <h6 className="section-title text-start text-uppercase mb-4">Quick Links</h6>
              <Link className="btn btn-link" to="/home">Home</Link>
              <Link className="btn btn-link" to="/about">About Us</Link>
              <Link className="btn btn-link" to="/buypolicies">Buy Policies</Link>
              <Link className="btn btn-link" to={isLoggedIn ? "/policylocker" : "/loginsignup"} state={!isLoggedIn ? { from: "/policylocker" } : null}>Policy Locker</Link>
              <Link className="btn btn-link" to="/privacypolicy">Privacy Policy</Link>
              <Link className="btn btn-link" to="/termsconditions">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid text-center p-3" style={{ backgroundColor: "#151B2E" }}>
        <div className="row justify-content-center">
          <div className="p-3" style={{ border: '1px solid #666', width: '1400px', margin: 'auto' }}>
            <div className="row g-2 text-white text-justify ">
              <p className="mb-0">
                IRDAI Reg no: IMF09320720250832. Insurance Licence Category: Composite (valid from 22/07/2025 to 21/07/2028). | <span>CIN : U66220MP2024PTC071898</span>
              </p>
              <p className="mb-0">
                Disclaimer : The information contained in this website is presented purely for information purposes only provided as service to the internet community at large. It does not constitute insurance advice and we do not guarantee the accuracy, adequacy or the completeness of the information contained here.  Insurance is the subject matter of the  Solicitation. Kindly read off policy related documents and take expert advice before taking any insurance or investment decisions.
              </p>
            </div>
          </div>
          <div>
            <p className="mt-2 text-white ">© Copyright 2025 | All Rights Reserved | Policy Samjho</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;